var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"error-message",attrs:{"data-external":"error-message"}},[_c('UCIcon',{attrs:{"icon":"fa-info"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }